// Import all images
import winterCampBanner from "assets/images/banners/winter-camp-banner.jpg";
import paDayBanner from "assets/images/banners/pa-day-camp-banner.jpg";
import banner1 from "assets/images/banners/banner_1.jpg";
import banner2 from "assets/images/banners/banner_2.jpg";
import banner3 from "assets/images/banners/banner_3.png";
import banner4 from "assets/images/banners/banner_4.png";
import workCockIcon from "assets/icons/work-cock.svg";
import workBg from "assets/images/bg/work-bg.png";
// import serviceImg from "assets/images/home/court-rent.jpg";
import serviceImg from "assets/images/banners/P5.jpg";
import shopImgRackets from "assets/images/home/professional-rackets.jpg";
import shopImgShuttlecocks from "assets/images/home/premium-shuttlecocks.jpg";
import shopImgSportswear from "assets/images/home/athletic-sportswear.jpg";
import coacheIcon1 from "assets/icons/coache-icon-03.svg";
import coacheIcon2 from "assets/icons/coache-icon-01.svg";
import coacheIcon3 from "assets/icons/coache-icon-02.svg";
import journeyImg from "assets/images/home/journey-with-royal-badminton-club.png";
// import bestServiceImg from "assets/images/home/unmatched-service.png";
import bestServiceImg from "assets/images/banners/P6.jpg";
// import aboutUsImg from "assets/images/home/about-us.png";
import aboutUsImg from "assets/images/banners/P4.jpg";
import planImg1 from "assets/icons/price-01.svg";
import planImg2 from "assets/icons/price-02.svg";
import planImg3 from "assets/icons/price-03.svg";
import workIcon1 from "assets/icons/work-icon1.svg";
import workIcon2 from "assets/icons/work-icon2.svg";
import workIcon3 from "assets/icons/work-icon3.svg";
import venueIndoorIcon from "assets/icons/venue-type-indoor.svg";
import venueOutdoorIcon from "assets/icons/venue-type-outdoor.svg";
import calendarIcon from "assets/icons/head-calendar.svg";
import aboutBanner1 from "assets/images/aboutus/banner-01.jpg";
import aboutBanner2 from "assets/images/aboutus/banner-02.jpg";
import aboutBanner3 from "assets/images/aboutus/banner-03.jpg";
import logo from "assets/images/logo.png";
import logoYellow from "assets/images/logo-yellow.png";
import dayjs from "dayjs";

export const CONFIG = {
  logoYellow: logoYellow,
  logoWhite: logo,
  websiteName: "Royal Badminton Club",
  dobMaxDate: dayjs().subtract(5, "year"),
  dobMaxDateForChild: dayjs().subtract(4, "year"),
  dobMinDateForChild: dayjs().subtract(16, "year"),
  dobMaxDateForAdult: dayjs().subtract(16, "year").subtract(1, "day"),
  dobMinDateForAdult: dayjs().subtract(80, "year").subtract(1, "day"),
  tax_data: {
    tax: 13,
    taxMassage: `Taxes & fees include of 13% HST.`,
  },
  clientContactData: {
    phoneNo: {
      href: "tel:+19059604881",
      label: "Holtby: +1 905-960-4881",
    },
    phoneNo2: {
      href: "tel:+16479614881",
      label: "Mayfield: +1 647-961-4881",
    },
    phoneNo3: {
      href: "tel:+18887478883",
      label: "Helpline: +1 888-747-8883",
    },
    email: {
      href: "mailto:hello@royalbadmintonclub.com",
      label: "hello@royalbadmintonclub.com",
    },
    email_2: {
      href: "mailto:info@royalbadmintonclub.com",
      label: "info@royalbadmintonclub.com",
    },
    address: (
      <>
        40 Holtby Ave, Unit 6, Brampton, <br />
        ON, L6X 2M1
      </>
    ),
    address2: (
      <>
        20 Tasker Rd Unit E12, Brampton, <br />
        ON, L6R 3Y2
      </>
    ),
    address3: (
      <>
        80 The East Mall Unit 1B, Etobicoke, <br />
        ON M8Z 5X1, Canada
      </>
    ),
    addressStr: "40 Holtby Ave, Unit 6, Brampton, ON, L6X 2M1",
    social: {
      facebook: "https://www.facebook.com/royalbadmintoncanada",
      instagram: "https://www.instagram.com/royalbadmintonclub",
      twitter: "https://twitter.com/royalclubcanada",
      youtube: "https://www.youtube.com/@RoyalBadmintonClub",
    },
  },
  pages_meta_data: {
    home: {
      title: "Join Royal Badminton Club for Top-Level Training and Fun",
      description:
        "Join Royal Badminton Club in Brampton for expert coaching, fun classes, and top-level training. Perfect for players of all ages and skill levels. Join today!",
      keywords: "",
    },
    venues: {
      title: "Find the Best Badminton Courts at Royal Badminton Club",
      description:
        "Discover top-tier badminton venues at Royal Badminton Club in Brampton. Enjoy state-of-the-art courts, expert coaching, and vibrant community play. Join us today!",
      keywords: "",
    },
    book_court: {
      title: "Book Badminton Court in Brampton at Royal Badminton Club",
      description:
        "Book your badminton court at the Royal Badminton Club in Brampton for a fun and energetic experience! Reserve your spot today and enjoy top-notch facilities.",
      keywords: "",
    },
    booking_query: {
      title: "Royal Badminton Club - Drop your queries",
      description:
        "Drop your queries at Royal Badminton Club and get a response from our team. We are here to help you with any questions you have.",
      keywords: "",
    },
    parental_waiver: {
      title: "Royal Badminton Club - Parental Consent and Liability Waiver",
      description:
        "Please fill the below form to consent to the liability waiver.",
      keywords: "",
    },
    training: {
      title: "Private Team Lessons at Royal Badminton Club - Join Now!",
      description:
        "Enhance your game with private team lessons at Royal Badminton Club! Join now for expert coaching, tailored training, and elevate your badminton skills!",
      keywords: "",
    },
    blogs: {
      title: "Royal Badminton Club - Blogs",
      description:
        "Join Royal Badminton Club in Brampton for expert coaching, fun classes, and top-level training. Perfect for players of all ages and skill levels. Join today!",
      keywords: "",
    },
    school_fund_raising_program: {
      title: "School Community Fundraising Program | Royal Badminton Club",
      description:
        "Enroll in our badminton program using your school's promo code and get 10% off. Your school's SAC also receives a 10% kickback for every enrollment. A great way to stay active and give back!",
      keywords:
        "school fundraising, badminton program, royal badminton club, etobicoke, badminton coaching",
    },
    badminton_beginners_programs: {
      title: "Badminton Kids Beginner program | Royal Badminton Club",
      description:
        "Enroll your child in our Badminton Kids Beginner program at Royal Badminton Club. Expert coaching, structured learning, and fun sessions.",
      keywords:
        "badminton kids beginner program, youth badminton, royal badminton club, etobicoke, badminton coaching for kids",
    },
    pa_day_badminton_camp: {
      title: "PA Day Badminton Camp | Royal Badminton Club",
      description:
        "Full day of badminton, skill development and fun for elementary school students across TDSB, PDSB and Catholic school boards.",
      keywords:
        "PA day badminton camp, royal badminton club, kids badminton camp, etobicoke badminton, PA day camp toronto, youth sports camp",
    },
    winter_badminton_camp: {
      title: "Winter Badminton Camp 2026-2027 | Royal Badminton Club",
      description:
        "Smash, learn and make friends this winter! Full day youth winter badminton camp for ages 5-16. Dec 21, 2026 – Jan 1, 2027 at Royal Badminton Club Etobicoke.",
      keywords:
        "winter badminton camp, kids winter camp, youth sports camp, royal badminton club, etobicoke winter camp, holiday badminton camp, competitive badminton camp",
    },
  },
  forbidden_routes: {
    layout: {
      home: false,
      venues: false,
      book_court: false,
      booking_query: false,
      parental_waiver: false,
      membership: false,
      drop_in: false,
      training: false,
      shop: false,
      blogs: false,
      about_us: false,
      contact_us: false,
      privacy_policy: false,
      terms_conditions: false,
      faqs: false,
      school_fund_raising_program: false,
      badminton_beginners_programs: false,
      pa_day_badminton_camp: false,
      winter_badminton_camp: false,
      delete_account: false,
    },
    auth: {
      login: false,
      sign_up: false,
      verify_otp: false,
      forgot_password: false,
      reset_password: false,
    },
    user: {
      dashboard: false,
      my_bookings: false,
      my_profile: false,
      trainees: false,
      profile_settings: false,
      drop_in_players: false,
      booking_query: false,
    },
  },
};

export const PAGES_CONTENT = {
  home: {
    hero: {
      heroBannerSlides: [
        {
          only_show_till_date: dayjs("2027-01-01"),
          id: "banner_winter_camp",
          image: winterCampBanner,
          rating: 5,
          ratingLabel: "Smash, Learn & Make Friends This Winter!",
          // headline: "Competitive & Non-Competitive Youth Training (Ages 5–16)",
          title: "Winter Badminton Camp",
          points: [
            {
              iconType: "calendar",
              label: "Camp Dates",
              value: "Dec 21, 2026 – Jan 1, 2027",
              extra: "(Full Camp, Weekly or Daily)",
            },
            {
              iconType: "time",
              label: "Camp Hours",
              value: "9:00 AM – 4:00 PM",
              extra: "· Open Every Day (No Holiday Breaks)",
              extraHighlight: true,
            },
            {
              iconType: "users",
              label: "Ages & Tracks",
              value: "Ages 5–16",
              extra: "(Competitive Advanced & Non-Competitive Fun)",
            },
          ],
          discounts: [
            {
              discount: "10% OFF",
              title: "GROUP DISCOUNT",
              desc: "For groups of 3+ (registered together)",
            },
            {
              discount: "10% OFF",
              title: "BOTH WEEKS",
              desc: "Register for both weeks (Dec 21 – Jan 1)",
            },
          ],
          ctaText: "Register for Winter Camp",
          ctaHref: "/winter-camp",
        },
        {
          id: "banner_pa_day",
          image: paDayBanner,
          rating: 5,
          ratingLabel: "GTA School Boards PA Days · Ages 5–14",
          // headline: "Full-Day & Half-Day Skill Development & Fun",
          title: "PA Day Badminton Camp",
          points: [
            {
              iconType: "calendar",
              label: "Camp Schedule",
              value: "All GTA School PA Days",
              extra: "(TDSB, PDSB, DCDSB & Catholic)",
            },
            {
              iconType: "time",
              label: "Camp Hours",
              value: "Full: (9 AM – 4 PM)",
              extra: "· Half: (9:00 AM – 12:00 PM)/(1 PM – 4 PM)",
              extraHighlight: true,
            },
            {
              iconType: "users",
              label: "Ages & Tracks",
              value: "Ages 5–14",
              extra: "(Skill Development, Drills & Fun Games)",
            },
          ],
          ctaText: "Register for PA Day Camp",
          ctaHref: "/pa-day",
        },
        {
          id: "banner_1",
          image: banner1,
          rating: 5,
          ratingLabel: "Trusted by 10000+ clients",
          headline: "We Provide World Class Badminton Premium Courts",
          title: "Crafting Champions",
          subtitle:
            "Shuttle to Success: Nurturing Future Olympians in Every Smash!",
          ctaText: "Book a Court Now",
          ctaHref: "/book-court",
        },
        {
          id: "banner_2",
          image: banner2,
          rating: 5,
          ratingLabel: "Certified Coaches & Pro Training",
          headline: "Professional Private & Team Badminton Coaching",
          title: "Train Like a Champion",
          subtitle:
            "Personalized coaching, advanced drills, and team sessions designed to elevate every aspect of your game.",
          ctaText: "Book a Training Session",
          ctaHref: "/training",
        },
        {
          id: "banner_3",
          image: banner3,
          rating: 5,
          ratingLabel: "Premium Quality Sports Gear",
          headline: "Your One-Stop Royal Pro Shop",
          title: "Gear Up for Greatness",
          subtitle:
            "From rackets to shoes and accessories — shop top-quality equipment trusted by professionals.",
          ctaText: "Shop Now",
          ctaHref: "https://royalproshop.com",
          externalLink: true,
        },
        {
          id: "banner_4",
          image: banner4,
          rating: 5,
          ratingLabel: "Easy Booking & Instant Play",
          headline: "Join Drop-In Matches & Meet New Players",
          title: "Play. Compete. Connect.",
          subtitle:
            "Book a court, join open sessions, and enjoy competitive matches with players at your level.",
          ctaText: "Join a Drop-In Game",
          ctaHref: "/drop-in",
        },
        // Add more slides as needed when you have more banner images
      ],
    },
    howItWorks: {
      images: {
        cockIcon: workCockIcon,
        workBg: workBg,
      },
      text: {
        title: "How It",
        afterText: "Works",
        subTitle: "Three simple steps to start your badminton journey",
      },
      cards: [
        {
          id: 1,
          image: {
            width: 40,
            height: 41,
            src: workIcon1,
            alt: "Icon",
          },
          card: {
            title: "Join Us",
            subTitle:
              "Create your account and become part of our premium badminton community with exclusive benefits.",
            btnText: "Register Now",
            href: "/sign-up",
          },
          permission: CONFIG.forbidden_routes.layout.sign_up,
        },
        {
          id: 2,
          image: {
            width: 40,
            height: 39,
            src: workIcon2,
            alt: "Icon",
          },
          card: {
            title: "Select Badminton Courts",
            subTitle:
              "Choose from our world-class facilities across multiple premium locations in your area.",
            btnText: "Go To Courts",
            href: "/venues",
          },
          permission: CONFIG.forbidden_routes.layout.venues,
        },
        {
          id: 3,
          image: {
            width: 40,
            height: 44,
            src: workIcon3,
            alt: "Icon",
          },
          card: {
            title: "Booking Process",
            subTitle:
              "Book your preferred time slot instantly with our easy-to-use online booking system.",
            btnText: "Book Now",
            href: "/book-court",
          },
          permission: CONFIG.forbidden_routes.layout.book_court,
        },
      ],
    },
    featuredVenues: {
      text: {
        title: "Featured",
        afterText: "Venues",
        subTitle:
          "Advanced sports venues offer the latest facilities, dynamic and unique environments for enhanced badminton performance.",
        buttonText: "View all Venues",
        buttonLink: "/venues",
      },
    },
    exploreServices: {
      images: {
        serviceImg: serviceImg,
      },
      text: {
        title: "Explore Our",
        afterText: "Services",
        subTitle:
          "Fostering excellence and empowering sports growth through tailored services for athletes, coaches, and enthusiasts.",
        serviceTitle: "Court Rent",
        serviceDescription:
          "Proudly pioneering innovation, we're the first in Canada to introduce a groundbreaking, first-of-its-kind flooring technology. Engineered to absorb shocks, our unique court surface ensures a playing experience that's not only thrilling but also allows enthusiasts to play for extended hours comfortably. Join us in redefining sports enjoyment with a court that prioritizes both performance and endurance",
        benefitsTitle: "Our Benefits",
        benefits: [
          "Tailored sports performance training enhances endurance, agility, and flexibility.",
          "Improve footwork, reaction time, and court maneuverability.",
          "Develop strength and power for stronger, precise shots.",
          "Knowledgeable trainers guide proper technique and progression.",
        ],
        buttonText: "Explore Courts",
        buttonLink: "/book-court",
      },
    },
    shopWidget: {
      text: {
        title: "Royal",
        afterText: "Pro Shop",
        subTitle:
          "Discover our premium badminton equipment and accessories. Elevate your game with our world-class products.",
      },
      products: [
        {
          id: 1,
          title: "Premium Stringing",
          price: "25",
          image: shopImgRackets,
          alt: "Premium Stringing",
          href: "https://royalproshop.com/collections/by-sports-badminton?filter.v.price.gte=&filter.v.price.lte=&filter.p.product_type=badminton+racket",
        },
        {
          id: 2,
          title: "Premium Shuttlecocks",
          price: "29.99",
          image: shopImgShuttlecocks,
          alt: "Premium Shuttlecocks",
          href: "https://royalproshop.com/collections/by-sports-badminton?filter.v.price.gte=&filter.v.price.lte=&filter.p.product_type=shuttlecock",
        },
        {
          id: 3,
          title: "Athletic Sportswear",
          price: "79.99",
          image: shopImgSportswear,
          alt: "Athletic Sportswear",
          href: "https://royalproshop.com/collections/apparel-tshirt",
        },
      ],
    },
    ourBenefits: {
      text: {
        title: "Our",
        afterText: "Benefits",
        subTitle: "Why choose Royal Badminton Club for your badminton journey?",
      },
      benefits: [
        {
          id: 1,
          iconKey: "trophy",
          title: "Championship Facilities",
          description:
            "Train on world-class courts used by professional athletes and tournaments.",
        },
        {
          id: 2,
          iconKey: "coaching",
          title: "Expert Coaching",
          description:
            "Learn from certified professionals with years of competitive experience.",
        },
        {
          id: 3,
          iconKey: "hours",
          title: "Flexible Hours",
          description:
            "Book courts from early morning to late night, seven days a week.",
        },
        {
          id: 4,
          iconKey: "community",
          title: "Vibrant Community",
          description:
            "Join a passionate community of badminton enthusiasts and competitors.",
        },
      ],
    },
    ourTrainingPrograms: {
      text: {
        title: "Our",
        afterText: "Training Programs",
        subTitle:
          "Explore our comprehensive training programs designed to enhance your badminton skills and elevate your game.",
      },
      programs: [
        {
          id: 1,
          iconKey: "beginner",
          title: "Beginner",
          description:
            "Learn fundamentals and basic techniques with certified coaches",
          durationWeeks: 8,
          enrollLink: "/private-team-lessons?sport_type=1&training_type=2",
        },
        {
          id: 2,
          iconKey: "intermediate",
          title: "Intermediate",
          description: "Develop advanced skills and competitive strategies",
          durationWeeks: 12,
          enrollLink: "/private-team-lessons?sport_type=1&training_type=2",
        },
        {
          id: 3,
          iconKey: "advanced",
          title: "Advanced",
          description: "Elite training for competitive players and tournaments",
          durationWeeks: 16,
          enrollLink: "/private-team-lessons?sport_type=1&training_type=2",
        },
      ],
    },
    ourFeatures: {
      images: {
        icon1: coacheIcon1,
        icon2: coacheIcon2,
        icon3: coacheIcon3,
      },
      text: {
        title: "Our",
        afterText: "Features",
        subTitle:
          "Discover your potential with our comprehensive training, expert trainers, and advanced facilities. Join us to improve your athletic career.",
        startsFromLabel: "Starts from",
      },
      features: [
        {
          id: 1,
          icon: coacheIcon1,
          title: "String Your Racket",
          price: "$14.99",
          description:
            "Elevate your game with our professional racket stringing service! Personalized tension, quality, and a quick turnaround for peak performance",
          permission: CONFIG.forbidden_routes.layout.book_court,
        },
        {
          id: 2,
          icon: coacheIcon2,
          title: "Group Coaching",
          price: "$89",
          description:
            "Benefit from expert guidance on our first-rate facilities, fostering skill development and camaraderie in a supportive group setting.",
          permission: CONFIG.forbidden_routes.layout.training,
        },
        {
          id: 3,
          icon: coacheIcon3,
          title: "Private Lessons",
          price: "$75",
          description:
            "Elevate your skills with focused training on our premium facilities, tailored to your individual needs for an exceptional learning journey.",
          permission: CONFIG.forbidden_routes.layout.training,
        },
      ],
      button: {
        text: "Have a Query?",
        link: "/booking-query",
      },
    },
    convenientSection: {
      text: {
        title: "Convenient & Flexible Scheduling",
        subTitle:
          "Book your courts anytime, anywhere. Our smart scheduling system makes it easy to find the perfect time slot for your game.",
        buttonText: "Book Your Slot",
        buttonLink: "/book-court",
      },
    },
    journeySection: {
      images: {
        journeyImg: journeyImg,
      },
      text: {
        title: "Start Your Journey With",
        titleHighlight: "Royal Badminton",
        titleEnd: "Today.",
        description1:
          "At Royal Badminton, we prioritize your satisfaction and value your feedback as we continuously improve and evolve our learning experiences.",
        description2:
          "Our instructors utilize modern methods for effective badminton lessons, offering introductory sessions for beginners and personalized development plans to foster individual growth.",
        approachTitle: "Stay Ahead With Our Innovative Approach:",
        features: [
          "Skilled Professionals",
          "Modern Techniques",
          "Intro Lesson",
          "Personal Development",
          "Advanced Equipment",
          "Interactive Classes For Easy Learning.",
        ],
        button1Text: "Join With Us",
        button1Link: "/sign-up",
        button2Text: "Learn More",
        button2Link: "/about-us",
      },
    },
    extraBenefits: {
      images: {
        bestServiceImg: bestServiceImg,
      },
      text: {
        title: "Extra Benefits, Unmatched",
        afterText: "Service Excellence",
        subTitle:
          "Advance your badminton journey with Royal Badminton: Exclusive perks, exceptional service.",
        counterTitle: "Courts",
        counterEnd: 9,
        counterDescription:
          "Well-maintained courts for optimal badminton experiences.",
        faqTitle: "Frequently Asked Questions",
        faqDescription:
          "Here are some frequently asked questions about badminton at Royal Badminton Club:",
      },
      faq: [
        {
          id: 1,
          question: "What is the duration of a badminton court booking?",
          answer:
            "Royal Badminton court bookings start from a minimum of 1 hour and can be reserved for up to 4 hours, providing flexibility to accommodate various playing preferences and schedules.",
        },
        {
          id: 2,
          question: "Can I rent badminton equipment at Royal Badminton?",
          answer:
            "Absolutely! We offer convenient equipment rental services to ensure you have everything you need for an enjoyable game. From quality rackets to shuttlecocks, we've got you covered, allowing you to dive into the badminton experience hassle-free.",
        },
        {
          id: 3,
          question:
            "Are there any coaching services available at Royal Badminton?",
          answer:
            "Certainly! At Royal Badminton, we take pride in offering exceptional coaching services tailored to players of all levels. Our experienced coaches, with over 10 years of expertise and a background in national-level play, provide top-notch training. We have the coaching program to elevate your game.",
        },
        {
          id: 4,
          question:
            "Can I join badminton leagues or tournaments at Royal Badminton?",
          answer:
            "Absolutely! Royal Badminton is your gateway to thrilling competition. Throughout the year, we organize multiple tournaments and leagues, creating opportunities for players to showcase their skills and enhance their game.",
        },
      ],
    },
    aboutUsSection: {
      images: {
        aboutUsImg: aboutUsImg,
      },
      text: {
        title: "About Us",
        subTitle:
          "Royal Badminton Club has been at the forefront of badminton excellence since 2010. Our commitment to providing world-class facilities and professional coaching has helped thousands of players achieve their goals.",
        features: [
          {
            title: "Our Mission",
            description:
              "To cultivate badminton excellence by providing premier facilities, expert coaching, and a supportive community for players of all levels.",
          },
          {
            title: "Our Vision",
            description:
              "To be recognized as the leading badminton club, producing champions and fostering a lifelong passion for the sport.",
          },
        ],
        buttonText: "Learn More",
        buttonLink: "/about-us",
      },
    },
    testimonials: {
      text: {
        title: "Our",
        afterText: "Testimonials",
        subTitle:
          "Glowing testimonials from passionate badminton enthusiasts worldwide, showcasing our exceptional services.",
      },
      testimonials: [
        {
          id: 1,
          title: "Excellent Professionalism!",
          content:
            "This is the best badminton place with world class facilities, they have very nice courts which are properly installed for the professionals, I could clearly see the difference between other places in Brampton. If you are looking for a recreational facility, this club is your best bet in town. Try once.",
          ownerName: "Mukesh Kumar",
        },
        {
          id: 2,
          title: "Personalized Attention",
          content:
            "This badminton club stands out as one of the best I've visited. It has excellent facilities, friendly staff, and inclusive atmosphere. I highly recommend this club.",
          ownerName: "Vikas",
        },
        {
          id: 3,
          title: "Quality Matters!",
          content:
            "Great court! Fresh air environment which is good for badminton players, lighting is bright and the floor has a good maintenance. I recommend people who love to play badminton come here to play.Best facility in the town for kids to learn.",
          ownerName: "Ashwin Singh",
        },
        {
          id: 4,
          title: "Quality Matters!",
          content:
            "I recently visited Royal Badminton and was impressed by the facility's exceptional quality and the delightful atmosphere it offers. The state-of-the-art amenities and friendly ambiance make it a standout choice for badminton enthusiasts. I highly recommend it for a great sporting experience.",
          ownerName: "Ravinder Chauhan",
        },
      ],
    },
    excellentPlans: {
      images: {
        workBg: workBg,
        planImg1: planImg1,
        planImg2: planImg2,
        planImg3: planImg3,
      },
      text: {
        title: "We Have Excellent",
        afterText: "Plans For You",
        subTitle:
          "Choose our plans for uninterrupted access to our premium badminton facilities. Join us and experience convenient excellence.",
        recommendedLabel: "Recommended",
        groupMembershipLabel: "Group Membership",
        perMonthLabel: "Per Month",
        choosePlanButtonText: "Choose Plan",
        planIncludesLabel: "Plan includes",
      },
    },
    blogs: {
      text: {
        title: "The Latest",
        afterText: "Blogs",
        subTitle:
          "Get the latest buzz from the badminton world- stay informed and inspired by the thrilling updates and remarkable achievements in the sport.",
        buttonText: "View all Blogs",
        buttonLink: "/blogs",
        minToReadLabel: "Min To Read",
        readMoreLabel: "Read More",
      },
    },
  },
  venue_details: {
    images: {
      venueIndoorIcon: venueIndoorIcon,
      venueOutdoorIcon: venueOutdoorIcon,
      calendarIcon: calendarIcon,
    },
    text: {
      venueTypeLabel: "Venue Type",
      ownerLabel: "Owner",
      overviewTitle: "Overview",
      offersTitle: "Offers",
      rulesTitle: "Rules",
      amenitiesTitle: "Amenities",
      locationTitle: "Location",
      venueLocationLabel: "Our Venue Location",
      establishedDateLabel: "Established Date",
      bookCourtTitle: "Book a Court",
      startsFromLabel: "Starts From :-",
      perHourLabel: "/hr",
      guestsLabel: "up to 6 guests",
      bookNowButtonText: "Book Now",
      defaultOwnerName: "Brampton Club",
    },
    defaultData: {
      includes: [
        "Court Rentals",
        "Private Lessons",
        "Group Lessons",
        "Drop - In Sessions",
        "Racket Rentals",
        "Shoe Rentals",
        "Pro Shop",
      ],
      rules: [
        "48 hours notice is required for cancellation. Otherwise, there is no refund.",
        "Please wear professional badminton shoes or Non-Marking Shoes with light-colored soles. If not, it was not allowed to play in the courts.",
        "The club is not responsible for any injury, losses, and damages incurred during the use of facilities or participating in activities.",
        "The maximum number of people is 6 for one court.",
        "Non-club coaches or multi-ball training are not allowed at the club.",
        "Please keep the courts clean, any drink and food are not allowed in the courts.",
        "Please change your shoes before entering the play area. (Winters - Make sure you remove snow shoes at the main entrance door)",
        "All items will be kept for two weeks only which are found at the club. If no one picks them up within the period, they will be cleared as unclaimed items.",
        "Smoking or e-cigarettes is not allowed in the club.",
        "Pets are not allowed in the club.",
        "We might adjust your court number based on our training schedule.",
      ],
      amenities: [
        "Air Conditioning & Heating",
        "Restrooms - Indoor",
        "Parking",
        "Waiting Areas",
        "Spectator Seating",
        "Stretching Areas",
        "Change Room",
        "First Aid",
        "Wi-fi",
      ],
    },
  },
  blogs: {
    text: {
      emptyMessage: "No Blogs Found!",
      breadcrumbLabel: "Blogs",
    },
  },
  blog_detail: {
    text: {
      shareTitle: "Check out this blog post!",
      shareLabel: "Share on:",
      defaultAuthorName: "Brampton Club",
      breadcrumbLabel: "Blogs",
      breadcrumbHref: "/blogs",
    },
  },
  about_us: {
    images: {
      banner1: aboutBanner1,
      banner2: aboutBanner2,
      banner3: aboutBanner3,
    },
    text: {
      whoWeAreTitle: "Who We Are?",
      whoWeAreParagraphs: [
        "Welcome to Royal Badminton Club - Where Passion Meets Performance!",
        "At Royal Badminton Club, we're more than just a club; we're a community of badminton enthusiasts united by our love for the game. Founded with a vision to elevate the badminton experience in our region, we strive to provide a welcoming and inclusive environment for players of all ages and skill levels.",
        "Our state-of-the-art facilities, world-class coaching, and vibrant atmosphere make us the premier destination for badminton aficionados seeking to hone their skills, compete, and forge lifelong friendships. Whether you're a seasoned player or stepping onto the court for the first time, we're here to support your journey to excellence.",
        "Join us at Royal Badminton Club and experience the thrill of badminton like never before. Together, let's unleash our passion, elevate our game, and write our own chapter in the storied history of this dynamic sport.",
        "Welcome to the Royal Badminton Club family - where every shuttlecock serves as a symbol of our shared dedication to the game we love.",
      ],
      visionTitle: "Your Vision",
      visionParagraphs: [
        "At Royal Badminton Club, our vision is clear: to cultivate a thriving community united by a passion for badminton. We envision a future where players of all ages and backgrounds come together to elevate their skills, forge lasting connections, and experience the joy of competition.",
        "Through world-class coaching, state-of-the-art facilities, and a culture of inclusivity, we strive to empower individuals to reach their full potential on and off the court. Together, we aim to shape the future of badminton, one smash at a time.",
      ],
      missionTitle: "Our Mission",
      missionText:
        "We provide coaches and players with a seamless platform for connectivity, personalized insights, and educational resources. Together, we foster a collaborative community that supports growth and success in badminton.",
    },
  },
  contact_us: {
    text: {
      contactInfoTitle: "Contact Information",
      emailTitle: "Email Address",
      phoneTitle: "Phone Number",
      locationTitle: "Location",
      formTitle: "Reach out to us and let's smash your inquiries",
    },
  },
  faqs: {
    text: {
      generalIssuesTitle: "General Issues",
      bookingFaqsTitle: "Booking FAQs",
    },
  },
  privacy_policy: {
    text: {
      mainTitle: "Privacy Policy",
      sections: {
        introduction: {
          title: "Privacy Policy",
          content:
            "At Royal Badminton Club, we are committed to protecting the privacy and confidentiality of our website visitors and members. This Privacy Policy outlines how we collect, use, disclose, and safeguard your personal information when you visit our website or engage with our services.",
        },
        informationWeCollect: {
          title: "Information We Collect",
          content:
            "We may collect personal information from you when you visit our website, register for membership, book courts or training sessions, or communicate with us via email or other channels. This may include but is not limited to your name, contact details, payment information, and any other information you voluntarily provide to us.",
        },
        howWeUse: {
          title: "How We Use Your Information",
          intro: "We may use your personal information to:",
          list: [
            "Provide and personalize our services.",
            "Process bookings and payments.",
            "Communicate with you about your bookings, membership, or inquiries.",
            "Improve our website, services, and customer experience.",
            "Comply with legal and regulatory requirements.",
            "Photographs and Videos.",
          ],
          photosContent:
            "By participating in activities at Royal Badminton Club, you consent to the use of your photographs and videos for promotional purposes. We may use these images and videos on our website, social media channels, marketing materials, and other promotional activities. If you have any concerns about the use of your images or videos, please contact our management team.",
        },
        security: {
          title: "Security of Your Information",
          content:
            "We take reasonable precautions to protect your personal information from unauthorized access, use, or disclosure. However, please be aware that no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee the absolute security of your information.",
        },
        complaints: {
          title: "Handling of Personal Data Complaints",
          intro:
            "If you believe that your personal data has been mishandled by us, please follow our complaint resolution procedure:",
          list: [
            "Upon receiving your complaint, we will promptly acknowledge its receipt and respond within 30 days.",
            "We will take the necessary steps to verify the authenticity of the complaint and the contact details you have provided.",
            "If additional information is required to address the complaint, we will seek it.",
            "If applicable, we will suggest potential solutions such as procedures for access, correction, or other suitable remedies. These suggestions are often provided in a confidential and without-prejudice manner.",
            "If, after 30 days, we have not responded to your complaint or it remains unresolved to your satisfaction, you have the option to escalate the matter to an external dispute resolution scheme to which we are affiliated.",
          ],
        },
        contactUs: {
          title: "Contact Us",
          content:
            "If you have any questions, concerns, or requests regarding this Privacy Policy or the handling of your personal information, please contact us at {email}. We are here to assist you and address any issues promptly and effectively. Any legal notice should be mail to : {address}.",
        },
        changes: {
          title: "Changes to this Privacy Policy",
          content1:
            "We reserve the right to update or modify this Privacy Policy at any time without prior notice. Any changes will be effective immediately upon posting on our website. We encourage you to review this Privacy Policy periodically for any updates.",
          content2:
            "By using our website or engaging with our services, you consent to the terms of this Privacy Policy.",
          lastUpdated: "Last updated: <strong>03rd February, 2024</strong>",
          finalContent:
            "This Privacy Policy is designed to provide clear guidelines on how we handle your personal information and ensure transparency in our data practices. If you have any questions or concerns, please don't hesitate to reach out to us at {email}.",
        },
      },
    },
  },
  terms_condition: {
    text: {
      sections: {
        introduction: {
          title: "Introduction",
          content:
            "Welcome to the Royal Badminton Club. By accessing or using our website and services, you agree to comply with and be bound by the following terms and conditions. Please read them carefully. If you do not agree to these terms, you should not use our website or services.",
        },
        bookingRules: {
          title: "Booking Rules",
          slotReservation: {
            title: "Slot Reservation",
            list: [
              "Slots can be reserved on an hourly basis. (No 30 minutes slots)",
              "Reservations can be made through our online booking system.",
            ],
          },
          slotAvailability: {
            title: "Slot Availability",
            list: [
              "Slot availability is on a first-come, first-served basis.",
              "The club reserves the right to cancel or modify reservations due to unforeseen circumstances.",
            ],
          },
          payment: {
            title: "Payment",
            list: [
              "Payments must be made at the time of booking for any paid reservations.",
            ],
          },
          cancellations: {
            title: "Cancellations and Refunds",
            list: [
              "Members may cancel their reservations up to 48 hours in advance without any penalty.",
              "Cancellations made within 48 hours of the reservation time may be subject to a cancellation fee.",
              "Refunds for cancellations will be processed according to the club's refund policy.",
            ],
          },
        },
        courtRental: {
          title: "Court Rental",
          list: [
            "If the court booking is not made through our website, the court rental fee must be received at least 48 hours before your booking time, or the court will be cancelled.",
            "All booking cancellations and/or refunds require 48 hours notice.",
            "Only proper badminton shoes are allowed on our courts.",
            "The club is not responsible for any injury, losses, and damages incurred during the use of facilities or participating in activities.",
            "The maximum number of people is 6 per court.",
            "Non-club coaches or multi-shuttle training are not allowed at the club.",
            "Please keep the courts clean; any drinks and food are not allowed on the courts.",
            "Please change your shoes before entering the club.",
            "Lost and found items will only be kept for 2 weeks.",
            "Smoking or e-cigarettes are not allowed in the club.",
            "Pets are not allowed in the club.",
            "We will adjust your court numbers according to the specific operational situation.",
          ],
        },
        privateLessons: {
          title: "Private Lessons & Team Training",
          list: [
            "All courses are non-transferable and non-refundable.",
            "48 hours notice is required for cancellation, otherwise, the club will deduct one lesson fee.",
            "The club is not responsible for any injury, losses, and damages incurred during the use of facilities or participating in activities.",
            "Parents or students will be notified if the club changes any original lessons; otherwise, the lessons will be held at the original time, including holidays and festivals.",
            "In case of absence, the club will still deduct one lesson fee.",
            "The package for all team training must be utilized within the designated time. If the make-up lessons cannot be completed during this time, it will be considered a waiver with no further make-up lessons provided.",
            "The team training discount is only applicable to the purchase of the whole semester.",
            "Coaches cannot be designated across levels. The club will appropriately arrange a private coach according to the student's level.",
          ],
        },
        codeOfConduct: {
          title: "Code of Conduct",
          list: [
            "Members are expected to behave in a respectful and sportsmanlike manner at all times.",
            "Any form of harassment, abuse, or unsportsmanlike conduct will not be tolerated and may result in suspension or termination of membership.",
          ],
        },
        liability: {
          title: "Liability",
          list: [
            "The Royal Badminton Club is not responsible for any personal injury, loss, or damage to personal property that occurs on the club premises.",
            "Members participate in activities at their own risk.",
          ],
        },
        privacyPolicy: {
          title: "Privacy Policy",
          list: [
            "The Royal Badminton Club is committed to protecting the privacy of its members. Personal information collected during membership registration and slot bookings will be used solely for club purposes and will not be shared with third parties without consent.",
          ],
        },
        amendments: {
          title: "Amendments",
          list: [
            "The Royal Badminton Club reserves the right to amend these terms and conditions at any time. Members will be notified of any significant changes via email or through announcements on our website.",
          ],
        },
        contactInfo: {
          title: "Contact Information",
          intro:
            "If you have any questions or concerns about these terms and conditions, please contact us at:",
        },
      },
    },
  },
  authentication: {
    login: {
      text: {
        heading: "Login User",
        subHeading:
          "Log in right away for our advanced sports software solutions, created to address issues in regular sporting events and activities.",
      },
    },
    signup: {
      text: {
        heading: "Register Now",
        subHeading:
          "Register now for our innovative sports software solutions, designed to tackle challenges in everyday sports activities and events.",
      },
    },
  },
  training: {
    text: {
      steps: ["Choose Plan", "User Details", "Select Slot", "Preview"],
    },
  },
  membership: {
    text: {
      steps: ["Choose Plan", "User Details", "Preview"],
    },
  },
  footer: {
    text: {
      description:
        "Premium badminton facilities for champions. Join us and elevate your game.",
    },
  },
};
